import React from 'react'
import { Modal, ModalTitle } from 'asterX-UI/Modals'
import { DialogContent, Grid } from '@material-ui/core'
import QRCode from 'react-qr-code'
import * as jwt from 'jsonwebtoken'
import AsterTitleTypography from 'asterX-UI/Typography/AsterTitleTypography'
const QrForKey = ({ open, onClose, data = {} }) => {
  const signed = jwt.sign(data, 'aster')
  return (
    <Modal open={open} onClose={onClose}>
      <ModalTitle onClose={onClose}>Получение ключа</ModalTitle>
      <DialogContent>
        <Grid
          container
          direction={'row'}
          justifyContent={'center'}
          alignItems={'center'}
          spacing={4}
        >
          <Grid item xs={12} md={12}>
            <AsterTitleTypography label={'Просканируйте для выдачи ключа'} />
          </Grid>
          <Grid item>
            <QRCode value={signed} title={'Выдача'} size={256} level={'L'} />
          </Grid>
        </Grid>
      </DialogContent>
    </Modal>
  )
}
export default QrForKey
